module.exports = " <h6>Il tuo browser non &egrave; aggiornato!</h6> <p>Aggiornalo per vedere questo sito correttamente. <a id=btnUpdateBrowser href=http://outdatedbrowser.com/it>Aggiorna ora</a></p> <p class=last><a href=# id=btnCloseUpdateBrowser title=Chiudi>&times;</a></p> ";


//////////////////
// WEBPACK FOOTER
// ./outdated-browser/lang/it.html
// module id = 824
// module chunks = 2